import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import qs from 'qs'
Vue.use(Vuex)
const state = {
    overviewList: [],
    overviewDatabaseList:[],
    radiusList: [],
    radiusAcctStatsList: []
}

const mutations = {
    SET_OVERVIEW_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.overviewList = [];
        if (parseData != null) {
            tData[userData.accountId + '-overviewList'] = parseData;
            state.overviewList = tData;
        }
    },
    SET_OVERVIEW_DATABASE_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.overviewDatabaseList = [];
        if (parseData != null) {
            tData['overviewDatabaseList'] = parseData;
            state.overviewDatabaseList = tData;
        }
    },
    SET_RADIUS_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.radiusList = [];
        if (parseData != null) {
            tData[userData.accountId + '-radiusList'] = parseData;
            state.radiusList = tData;
        }
    },
    SET_RADIUS_ACCT_STATS_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.radiusAcctStatsList = [];
        if (parseData != null) {
            tData[userData.accountId + '-radiusAcctStatsList'] = parseData;
            state.radiusAcctStatsList = tData;
        }
    },
}

const actions = {
    fetchOverviewListDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/overview/index/true')
                .then(res => {
                    Nprogress.done()
                    commit('SET_OVERVIEW_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchOverviewDatabaseListDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/overview/databases/true')
                .then(res => {
                    Nprogress.done()
                    commit('SET_OVERVIEW_DATABASE_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    getDatabaseNamesFromIp({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/overview/get_databaseNames', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    Nprogress.done()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    getDatabaseActiveFromIp({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/overview/get_database_active_session', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    Nprogress.done()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchRadiusListDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/overview/radius/true')
                .then(res => {
                    Nprogress.done()
                    commit('SET_RADIUS_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchRadiusAcctStatsListDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/overview/radiusacct/true')
                .then(res => {
                    Nprogress.done()
                    commit('SET_RADIUS_ACCT_STATS_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
}

const getters = {
    getOverviewListGetters: state => {
        return state.overviewList;
    },
    getOverviewDatabaseListGetters: state => {
        return state.overviewDatabaseList;
    },
    getRadiusListGetters: state => {
        return state.radiusList;
    },
    getRadiusAcctStatsListGetters: state => {
        return state.radiusAcctStatsList;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
